import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5.2,17.22a1,1,0,0,1-1.42.06l-5-4.54A1,1,0,0,1,10.5,12V6.5a1,1,0,0,1,2,0v5.06l4.63,4.25A1,1,0,0,1,17.2,17.22Z",
		style: { fill: "currentColor" }
	})
});
export { SvgClock as ReactComponent };
